module.exports = __webpack_public_path__ + "img/residencial_eu.3e5f9986.png";